var _path, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarker1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4262 21.8493C16.9024 21.8493 21.3172 17.3491 21.3172 11.8285C21.3172 6.30783 16.9024 1.80762 11.4262 1.80762C5.94989 1.80762 1.53516 6.30783 1.53516 11.8285C1.53516 17.3491 5.94989 21.8493 11.4262 21.8493Z",
    fill: "rgb(106, 81, 201)",
    fillOpacity: 0.3,
    stroke: "rgb(106, 81, 201)",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.4259,
    cy: 11.8284,
    rx: 3.45762,
    ry: 3.50811,
    fill: "rgb(106, 81, 201)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker1);
export default __webpack_public_path__ + "static/media/marker1.c82752ffd20b9d8745019133b2fad068.svg";
export { ForwardRef as ReactComponent };